<button 
  class="circle-icon-button"
  [class.disabled]="disabled"
  [matMenuTriggerFor]="matMenuTriggerFor"
  [disabled]="disabled"
  [matTooltip]="title || ''"
  [matTooltipDisabled]="!title"
  (click)="onClick($event)"
  #matMenuTrigger="matMenuTrigger">
  <mat-icon>{{ icon }}</mat-icon>
</button>